/**
 * Utility functions for handling images
 */

// Function to ensure images are imported properly
export const getImagePath = (imagePath) => {
  // For imported images, return as is
  if (
    typeof imagePath === 'object' ||
    (typeof imagePath === 'string' && !imagePath.startsWith('/'))
  ) {
    return imagePath;
  }

  // For paths that start with /images
  if (imagePath.startsWith('/images')) {
    // In production mode with Vite, we need to adjust the path to start from the root
    // where the files will be copied by copyImages.js
    return imagePath; // Keep the /images prefix
  }

  // If we've migrated from Gatsby and the path doesn't have the correct structure,
  // log a warning to help with debugging
  console.warn('Image path format not recognized:', imagePath);
  return imagePath;
};

// Preload critical images to avoid FOUC (Flash of Unstyled Content)
export const preloadImages = (imagePaths) => {
  if (!Array.isArray(imagePaths)) return;

  imagePaths.forEach((path) => {
    const img = new Image();
    img.src = getImagePath(path);
  });
};

// Helper function to fix image paths in data objects
export const fixImagePaths = (data) => {
  if (!data) return data;

  // If it's a string that looks like an image path
  if (typeof data === 'string' && data.startsWith('/images')) {
    return getImagePath(data);
  }

  // If it's an array, process each item
  if (Array.isArray(data)) {
    return data.map((item) => fixImagePaths(item));
  }

  // If it's an object, process each property
  if (typeof data === 'object') {
    const result = {};
    for (const key in data) {
      result[key] = fixImagePaths(data[key]);
    }
    return result;
  }

  // Otherwise return as is
  return data;
};
